export default __webpack_public_path__ + "static/media/CHENNAI-7.c3d39734.webp";